const helpers = {
    getFormMessage: (success, message, state, text, color, data, event) => {
        // Display 
        message.open = state;
        message.text = text;
        message.color = color;
        // Push Data (GA)
        if ( success && process.env.NODE_ENV !== 'development' && event ) { dataLayer.push({ 'event': event.replace('/', '') }); }
        // Fail
        if ( !success ) { console.log(data); }
    },
    getMessage: (message, state, text, color) => {
        message.open = state;
        message.text = text;
        message.color = color;
    },
    firstLetterUppercase: (title) => {
        return title.charAt(0).toUpperCase()+title.slice(1);
    },
    replaceCharacter: (title, character, replace) => {
        const theTitle = title.toString();
        const regExp = new RegExp(character, "g");
        const replaceTitle = theTitle.replace(regExp, replace);

        return replaceTitle
    },
    capitalizeReplace: (title) => {
        const theTitle = title.toString();
        const replaceTitle = theTitle.replace(/-/g, ' ');
        const capitalizeTitle = replaceTitle.charAt(0).toUpperCase()+replaceTitle.slice(1);

        return capitalizeTitle;
    },
    capitilzeEachWord: (title, character) => {
        const theTitle = title.toString();
        const splitTitle = theTitle.split(character);
        const arrayTitle = splitTitle.map((item) => {
            return item.charAt(0).toUpperCase()+item.slice(1);
        })
        const arrayTitleString = arrayTitle.toString();
        const replaceTitle = arrayTitleString.replace(/,/g, ' ');

        return replaceTitle;
    },
    upperCaseReplace: (title) => {
        const theTitle = title.toString();
        const replaceTitle = theTitle.replace(/-/g, ' ');
        const uppercaseTitle = replaceTitle.toUpperCase();

        return uppercaseTitle;
    },
    getBlackImage: (price, vat) => {
        let blackImage = '';
        let currPrice = price;

        if ( vat === 1 ) { currPrice = currPrice * 1.24; }

        if ( currPrice < 20000 ) { blackImage = '/images/black-car-2025-v1.png'; };
        if ( currPrice > 20001 && currPrice < 33000 ) { blackImage = '/images/black-car-2025-v2.png'; };
        if ( currPrice > 33001 && currPrice < 45000 ) { blackImage = '/images/black-car-2025-v3.png'; };
        if ( currPrice > 45001 && currPrice < 57000 ) { blackImage = '/images/black-car-2025-v4.png'; };
        if ( currPrice > 57001 && currPrice < 73000 ) { blackImage = '/images/black-car-2025-v5.png'; };
        if ( currPrice > 73001 ) { blackImage = '/images/black-car-2025-v6.png'; };

        return blackImage
    },
    getBlackPrice: (price, vat) => {
        let newPrice = '';
        let currPrice = price;

        if ( vat === 1 ) { currPrice = currPrice * 1.24; }

        if ( currPrice < 20000 ) { newPrice = '(-500€)'; }
        else if ( currPrice > 20001 && currPrice < 33000 ) { newPrice = '(-1000€)'; }
        else if ( currPrice > 33001 && currPrice < 45000 ) { newPrice = '(-1500€)'; }
        else if ( currPrice > 45001 && currPrice < 57000 ) { newPrice = '(-2000€)'; }
        else if ( currPrice > 57001 && currPrice < 73000 ) { newPrice = '(-3000€)'; }
        else if ( currPrice > 73001 ) { newPrice = '(-4000€)'; };

        return newPrice
    },
    getChristmasImage: (price, vat) => {
        let blackImage = '';
        let currPrice = price;

        if ( vat === 1 ) { currPrice = currPrice * 1.24; }

        if ( currPrice < 30000 ) { blackImage = '/images/christmas-2025-v1.png'; };
        if ( currPrice > 30001 && currPrice < 75000 ) { blackImage = '/images/christmas-2025-v2.png'; };
        if ( currPrice > 75001 ) { blackImage = '/images/christmas-2025-v3.png'; };

        return blackImage
    },
    getChristmasPrice: (price, vat) => {
        let newPrice = '';
        let currPrice = price;

        if ( vat === 1 ) { currPrice = currPrice * 1.24; }

        if ( currPrice < 30000 ) { newPrice = '(-500€)'; }
        else if ( currPrice > 30001 && currPrice < 75000 ) { newPrice = '(-1000€)'; }
        else if ( currPrice > 75001 ) { newPrice = '(-3000€)'; };

        return newPrice
    },
    toLocaleReplace: (title) => {
        return title.toLocaleString('el').replace(/,/g, '.');
    },
    convertTimeToMonth: (time) => {
        let newTime = new Date(time);
        let convertedTime = `${newTime.getDate()} ${newTime.toLocaleString('el-GR', { month: 'long' })}  ${newTime.getFullYear()}`
        return convertedTime
    },
    popupTrigger: (id) => {
        window.localStorage.setItem('popup_autobesikos', id);
    },
    padNumber(number, length, character) {
        let pad_char = typeof character !== 'undefined' ? character : '0';
        let pad = new Array(1 + length).join(pad_char);
        return (pad + number).slice(-pad.length);
    }
}

export default helpers